<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-10 10:31:59
    Description : 文件上传通用页面组件
  -->
  <div class="main">
    <div class="header page">
      <div class="background" :style="{ background: `url(${img[types]})`, backgroundSize: '1200px 100px' }">
        <div class="title">上传进度（{{ typeobj[types] }}）</div>
        <span class="name">共</span>
        <span class="content">{{ fileList.length }}</span>
        <span class="name">个项目</span>
        <span class="name line">|</span>
        <span class="name">完成</span>
        <span class="content">{{ getSuccessLength() }}</span>
        <span class="name">个</span>
        <span class="name line">|</span>
        <span class="name">剩</span>
        <span class="content">{{ fileList.length - getSuccessLength() }}</span>
        <span class="name">个</span>
        <span class="name line">|</span>
        <span class="name">总进度</span>
        <span class="content">{{ getTotalProgress() }}%</span>
        <span class="name line">|</span>
        <span class="name">平均速度</span>
        <span class="content">
          {{ getAvgSpeed() == 0 ? "0 Mb" : getSize(getAvgSpeed()) }}/s
        </span>
        <span class="name line">|</span>
        <span class="name">预计耗时</span>
        <span class="content">{{ getRemainTime() }}</span>
        <div class="control">
          <div v-if="pauseAllShow" class="item" @click="pauseAll">
            <pause theme="outline" size="18" />
            <span class="content">全部暂停</span>
          </div>
          <div v-if="!pauseAllShow" class="item" @click="resumeAll">
            <play-one theme="outline" size="18" />
            <span class="content">全部开始</span>
          </div>
          <div class="item" @click="clearAll">
            <close-small theme="outline" size="18" />
            <span class="content">全部取消</span>
          </div>
        </div>
      </div>
    </div>
    <div class="upload page">
      <div class="left">
        <div class="title">
          <span>已添加</span>
          <span style="color: #f04e56; margin: 0 4px">{{
            fileList.length
          }}</span>
          <span>个视频</span>
        </div>
        <div class="file-list">
          <el-upload
            v-show="$parent.settingVisible"
            ref="upload"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :file-list="fileList"
            :http-request="(file) => upload(file)"
            :on-change="handleChange"
          >
            <div class="upload-add">
              <i class="el-icon-plus"></i>
              <span>添加文件</span>
            </div>
          </el-upload>
          <div
            class="upload-add"
            v-show="!$parent.settingVisible"
            @click="$message.warning('请先设置参数再添加文件')"
          >
            <i class="el-icon-plus"></i>
            <span>添加文件</span>
          </div>
          <el-scrollbar class="list">
            <div
              class="item"
              :class="{
                checked: checked === i,
                success: item.status === 'success',
              }"
              v-for="(item, i) in fileList"
              :key="i"
              @click="fileListChange(i)"
            >
              <div
                class="progress"
                :style="{
                  width: `${item.percentage}%`,
                  display: item.status !== 'success' ? 'block' : 'none',
                }"
              ></div>
              <div class="name">{{ item.name }}</div>
              <div class="percent">{{ item.percentage || 0 }}%</div>
              <div class="control">
                <div
                  v-if="item.status === 'pause'"
                  @click.stop="resumeUpload(i)"
                >
                  <play-one theme="outline" size="24" />
                </div>
                <div
                  v-if="item.status === 'uploading'"
                  @click.stop="uploadPause(i)"
                >
                  <pause theme="outline" size="24" />
                </div>
                <div
                  v-if="item.status !== 'ready'"
                  @click.stop="setting(i)"
                  class="setting"
                >
                  <setting-two theme="outline" size="20" />
                </div>
                <div>
                  <div @click.stop="close(i)">
                    <close-small theme="outline" size="24" />
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import OSS from "ali-oss";
import { uploadCover } from "@/api/upload";
import { Pause, CloseSmall, PlayOne, SettingTwo } from "@icon-park/vue";
import { getSize, secondToDate } from "@/utils/utils";

export default {
  name: "gaia-upload",
  components: {
    Pause,
    CloseSmall,
    PlayOne,
    SettingTwo,
  },
  model: {
    prop: "formdata",
    event: "formChange",
  },
  props: {
    formdata: {
      type: Object,
      default: {},
    },
    types: {
      type: String,
      default: "",
    },
    formatList: {
      type: Array,
      default: [],
    },
  },
  watch: {
    formdata: {
      handler(form) {
        this.$emit("formChange", form);
      },
      deep: true,
    },
    checked(new_val, old_val) {
      if (new_val != old_val) {
        this.fileListChange(new_val);
      }
    },
  },
  data() {
    return {
      typeobj: {
        video: "视频素材",
        picture: "图片素材",
        music: "音频素材",
        template: "模板素材",
        virtual: '虚拟资产素材',
        other: "其它素材",
        gaia48: "Gaia48",
      },
      resourcesUrl: process.env.VUE_APP_RESOURCES_URL,
      type: "",
      img: {
        video: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/video-background.png`,
        music: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/audio-background.png`,
        picture: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/image-background.png`,
        template: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/template-background.png`,
        virtual: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/virtual-background.png`,
        other: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/other-background.png`,
        gaia48: `${process.env.VUE_APP_IMAGEBASEURL}/web/img/gaia48.png`,
      },
      fileList: [],
      pauseAllShow: false,
      checked: 0,
    };
  },
  created() {
    this.type = this.$route.query.type;
  },
  methods: {
    /**
     * 取filelist的length
     */
    getFileListLength() {
      return this.fileList.length;
    },
    /**
     * 取文件大小 转单位
     */
    getSize(size) {
      return getSize(size);
    },
    /**
     * 计算成功个数
     */
    getSuccessLength() {
      let length = 0;
      this.fileList.map((el) => {
        el.status === "success" && length++;
      });
      return length;
    },
    /**
     * 计算总进度
     */
    getTotalProgress() {
      let fileList = this.fileList;
      if (!fileList.length) {
        return 0;
      }
      return parseInt((this.getSuccessLength() / fileList.length) * 100);
    },
    /**
     * 计算平均速度
     */
    getAvgSpeed() {
      let fileList = this.fileList;
      let speed = 0;
      let length = 0;
      fileList.map((el) => {
        if (el.status !== "ready") {
          const endUploadTime = el.endUploadTime || new Date().valueOf();
          length++;
          speed +=
            (el.percentage * el.size * 10) /
            (endUploadTime - el.startUploadTime);
        }
      });
      if (length === 0) {
        return 0;
      }
      return speed / length;
    },
    /**
     * 计算平均剩余时间
     */
    getRemainTime() {
      let fileList = this.fileList;
      let avgSpeed = this.getAvgSpeed();
      if (avgSpeed === 0) {
        return secondToDate(0);
      }
      let remainSize = 0;
      fileList.map((el) => {
        if (el.status === "uploading") {
          remainSize += parseInt(el.size - el.percentage * el.size * 0.01);
        }
      });
      return secondToDate(parseInt(remainSize / this.getAvgSpeed()));
    },

    /**
     * pause upload
     */
    uploadPause(i) {
      let file = this.fileList[i];
      file.OSS && file.OSS.cancel();
      file.status = "pause";
    },
    setting(i) {
      const id = this.fileList[i].form.id;
      open(`/desktop/gaia-material/${this.types}-update?id=${id}`);
    },
    close(i) {
      if (!this.$parent.settingVisible) {
        this.$message.warning("请先设置参数再点击删除");
        return;
      }
      let file = this.fileList[i];
      if (file.status === "uploading" || file.status === "pause") {
        this.$confirm("关闭上传进度将取消该视频上传，确定取消上传？")
          .then((_) => {
            this.uploadPause(i);
            this.fileList.splice(i, 1);
          })
          .catch((_) => {});
      } else {
        this.fileList.splice(i, 1);
      }
      if (i === 0 && this.fileList.length === 0) {
        this.clearForm();
      } else {
        this.fileListChange(0);
      }
    },
    handleChange(file, fileList) {
      const i = fileList.length - 1;
      let bool = false;
      this.fileList.map((el) => {
        if (file.name === el.name) {
          bool = true;
        }
      });
      if (bool && file.status === "ready") {
        this.$message.warning("已有同名文件存在, 请重新选择!");
        fileList.pop();
        return;
      } else if (file.status === "success") {
        fileList = this.fileList;
      } else if (!this.checkFormat(file.name)) {
        this.$message.error("选择的文件类型不符合要求, 文件名为: " + file.name);
        fileList.pop();
      } else {
        if (this.fileList.length < fileList.length) {
          fileList[fileList.length - 1].form = {
            ...this.formdata,
            ...{
              title: file.name,
              format: file.name.split(".")[file.name.split(".").length - 1],
              fileFormat: file.name.split(".")[file.name.split(".").length - 1],
              size: file.size,
            },
          };
        }
        this.fileList = fileList;
        this.fileListChange(this.fileList.length - 1);
      }
      // console.log(file, this.fileList);
    },
    /**
     * 检测后缀名是否符合要求
     */
    checkFormat(name) {
      if (!name.includes(".")) {
        return false;
      }
      for (let i in this.formatList) {
        let temp = name.split(".");
        if (temp[temp.length - 1].toLocaleLowerCase() === this.formatList[i]) {
          return true;
        }
      }
      return false;
    },
    /**
     * 暂停全部正在上传
     */
    pauseAll() {
      this.pauseAllShow = false;
      this.fileList.map((el, i) => {
        el.status === "uploading" && this.uploadPause(i);
      });
    },
    /**
     * 开始所有暂停的上传
     */
    resumeAll() {
      this.pauseAllShow = true;
      this.fileList.map((el, i) => {
        el.status === "pause" && this.resumeUpload(i);
      });
    },
    /**
     * 清除所有上传
     */
    clearAll() {
      this.fileList.length > 0 &&
        this.$confirm("确认全部取消？")
          .then((_) => {
            this.pauseAll();
            this.fileList = [];
            this.clearForm();
          })
          .catch((_) => {});
    },
    fileListChange(i) {
      if (!this.$parent.settingVisible) {
        this.$message.warning("请先设置参数再点击切换");
        return;
      }
      this.checked = i;
      setTimeout(() => {
        // console.log("gaia", this.form, this.fileList[i].form);
        this.$emit("formChange", this.fileList[i].form);
      }, 0);
    },
    /**
     * 清空表单
     */
    clearForm() {
      let file = this.fileList[0];
      if (!file) {
        this.$parent.clearForm();
        return;
      }
      for (let key in file.form) {
        file.form[key] = "";
      }
    },
    submit(func = uploadCover, data) {
      this.fileList.map((el, i) => {
        this.upload(i, func);
      });
    },
    upload(i = this.checked, func, data) {
      let file = this.fileList[i];
      let name = file.name;
      if (file.status !== "ready") {
        this.$message.warning(`素材: ${file.name} 已应用, 请勿重复提交!`);
        return;
      }
      file.startUploadTime = new Date().valueOf();
      func(data)
        .then(({ uploadToken, worksId, msg }) => {
          if (msg === "not.permission") {
            this.$message.warning("抱歉, 您暂无该板块的上传权限, 请联系客服");
            throw new Error("无权限");
          }
          this.fileList[i].form.id = worksId;
          const ossConfig = {
            region: "oss-cn-hangzhou",
            accessKeyId: uploadToken.accessKeyId,
            accessKeySecret: uploadToken.accessKeySecret,
            stsToken: uploadToken.signature,
            bucket: uploadToken.bucket,
          };
          file.fileName = uploadToken.dir + uploadToken.fileName;
          file.OSS = new OSS(ossConfig);
          this.multipartUpload(file);
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("上传接口调用失败");
        });
    },
    /**
     * 恢复上传
     */
    resumeUpload(i) {
      // console.log(file);
      let file = this.fileList[i];
      file.status = "uploading";
      this.multipartUpload(file);
    },

    /**
     * aliyun-oss upload function
     */
    multipartUpload(file) {
      file.OSS.multipartUpload(file.fileName, file.raw, {
        progress: (p, checkpoint) => {
          // 更新进度
          file.status = "uploading";
          file.percentage = parseInt(p * 100);
          file.tempCheckpoint = checkpoint;
        },
        checkpoint: file.tempCheckpoint,
      }).then(
        (res) => {
          console.log(this.resourcesUrl + file.fileName);
          file.status = "success";
          file.endUploadTime = new Date().valueOf();
        },
        (err) => {
          if (err.name === "cancel") {
            console.log("已暂停上传");
            return;
          }
          this.$message.error("oss上传失败");
          console.log("err", err);
        }
      );
    },
  },
};
</script>
<style lang="less">
.el-form-item__label {
  padding-bottom: 0px !important;
}
.el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
.el-checkbox__label {
  font-size: 12px;
}
.el-checkbox__label {
  padding-left: 4px;
}
.el-input-group__append {
  padding: 0 10px;
}
.info-box {
  display: flex;
  justify-content: space-between;
  .item {
    width: 32%;
  }
  .name {
  }
  .box {
    border: 1px solid #dcdcdc;
    color: #909399;
    font-size: 12px;
    padding-left: 10px;
    cursor: pointer;
  }
}
</style>
<style lang="less" scoped>
@width: 1200px;
@min-width: 1300px;

.main {
  min-width: @min-width;
  padding-top: 100px;
  background: #f2f2f2;
}

.header {
  margin: 0 auto 20px;
  .background {
    height: 100px;
    padding: 25px 32px;
  }
  .title {
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .name {
    color: #8accff;
    font-size: 12px;
  }
  .content {
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    margin: 0 1.3px;
  }
  .line {
    margin: 0 8px;
    font-weight: bold;
  }
  .control {
    position: relative;
    display: flex;
    width: 200px;
    top: -30px;
    left: 920px;
    .item {
      width: 102px;
      color: #ffffff;
      font-size: 12px;
      .content {
        vertical-align: top;
        margin-left: 6px;
        user-select: none;
        cursor: pointer;
      }
    }
  }
}

.upload {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-bottom: 40px;
  height: 800px;

  .left {
    width: 664px;
    overflow-y: auto;
  }
  .right {
    width: 526px;
  }
  .left,
  .right {
    background: #ffffff;
    padding: 30px 20px;
  }
  .title {
    height: 14px;
    line-height: 14px;
    padding-left: 10px;
    margin-bottom: 28px;
    font-weight: 700;
    font-size: 12px;
    border-left: 4px solid #ff464c;
    color: #333;
  }
}

.file-list {
  @list-width: 626px;
  width: @list-width;

  .upload-add {
    display: block;
    width: 626px;
    height: 35px;
    line-height: 35px;
    border-radius: 4px;
    font-size: 14px;
    border: 1px dashed #007aff;
    background: #ededed;
    color: #007aff;
    text-align: center;
    cursor: pointer;
    i {
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .list {
    height: 600px;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .item {
    display: flex;
    width: @list-width;
    height: 35px;
    line-height: 35px;
    border-radius: 4px;
    margin-top: 6px;
    padding: 1px 20px 1px 20px;
    font-size: 12px;
    background: #f0f5fa;
    position: relative;
    color: #96afc8;
    box-sizing: border-box;
    cursor: pointer;
    .name {
      width: 50%;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
      z-index: 2;
    }
    .percent {
      width: 40%;
      text-align: center;
      z-index: 2;
    }
    .control {
      width: 10%;
      display: flex;
      justify-content: flex-end;
      // align-items: center;
      text-align: right;
      width: 20%;
      font-size: 20px;
      z-index: 2;
      .setting {
        margin-top: -2px;
      }
    }
  }

  .item.checked {
    border: 1px solid #007aff;
  }
  .item.success {
    color: #82d282;
    background: #dcfae6;
    transition: all 0.8s;
  }
  .progress {
    position: absolute;
    left: 0;
    height: 32px;
    border-radius: 4px;
    z-index: 1;
    background: #e0edfa;
    transition: all 0.2s;
  }
}
</style>
